// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"bridge-4"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M4 21.0004V8.00021L3.10005 3.50027M8 21.0004V8.00021L8.9 3.50027M20 21V8L20.9 3.5M16 21.0004V8.00021L15.1 3.50002M2 3.00042L9 3.00028C9.90938 3.00033 13.8757 2.99995 15 3.00001L22 3.00042","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Bridge4Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'bridge-4',
    ref,
    icon: element,
  },
));

Bridge4Icon.displayName = 'Bridge4Icon';

export default Bridge4Icon;
